import {IsEditActionType} from "../Constants/IsEditActionType";

export const setIsEdit = data => {
	return {
		type: IsEditActionType.IsEdit,
		payload: data,
	};
};
